import React from 'react';
import { observer } from 'mobx-react-lite';
import { cn } from 'src/domains/common/components/utils';
import { RadioCardPropsType } from 'src/domains/common/components/radio-card/radio-card.types';

export const RadioCard = observer(function RadioCard({
    name,
    value,
    label,
    description,
    isSelected,
    isDisabled = false,
    onSelect,
    dataTest,
    inputDataTest,
    className,
}: RadioCardPropsType): JSX.Element {
    return (
        <label
            className={cn(
                'flex items-start gap-3 cursor-pointer rounded-md border border-solid p-3 transition-colors',
                isSelected ? 'border-primary bg-primary/5' : 'border-border bg-background',
                isDisabled && 'opacity-50 cursor-not-allowed',
                className
            )}
            data-test={dataTest}
        >
            <input
                checked={isSelected}
                className='hidden'
                data-test={inputDataTest ?? dataTest}
                disabled={isDisabled}
                name={name}
                onChange={(): void => onSelect(value)}
                type='radio'
                value={value}
            />
            <span
                aria-hidden='true'
                className={cn(
                    'mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full border-2 border-solid',
                    isSelected ? 'border-primary' : 'border-muted-foreground'
                )}
            >
                {isSelected && <span className='size-2 rounded-full bg-primary' />}
            </span>
            <span className='flex flex-col gap-1'>
                <span className='text-sm font-medium leading-5 text-foreground'>{label}</span>
                {description === undefined ? null : (
                    <span className='text-sm leading-5 text-muted-foreground'>{description}</span>
                )}
            </span>
        </label>
    );
});
